import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormatHelper } from '../helpers';

@Pipe({
  name: 'multiline'
})
export class MultilinePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: unknown, trusted = false): unknown {
    if (!value || typeof value !== 'string') {
      return value;
    }

    let result = String(value);

    if (!trusted) {
      result = FormatHelper.escapeHtml(result);
      result = this.sanitizer.sanitize(SecurityContext.HTML, result) || '';
    }

    result = result.replace(/(\n|&#10;)/g, '<br>\n');

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }
}
